import dataService from 'services/dataService';
import {
  API_ACTION_TIME_TRACKER_CREATE,
  API_ACTION_TIME_TRACKER_DELETE,
} from 'services/dataService/resources/system';

interface ApiCreateResponse {
  actionTimeTrackerGuid: string;
  startTime: string;
}

interface CreateResponse {
  actionTimeTrackerGuid: string;
  startTime: Date;
}

export const createActionTimeTracker = async (
  startTime: Date,
): Promise<CreateResponse> => {
  const { data, error } = await dataService.createOne<ApiCreateResponse>(
    API_ACTION_TIME_TRACKER_CREATE,
    {
      startTime: startTime.toISOString(),
    },
  );

  if (error) {
    throw new Error(error);
  }

  if (!data) {
    throw new Error('No data returned from Create Action Time Tracker');
  }

  const startTimeFromServer = new Date(data.startTime);

  return {
    actionTimeTrackerGuid: data.actionTimeTrackerGuid,
    startTime: startTimeFromServer,
  };
};

export const deleteActionTimeTracker = async (guid: string): Promise<void> => {
  const { error } = await dataService.deleteOne(
    API_ACTION_TIME_TRACKER_DELETE,
    { id: guid },
  );

  if (error) {
    throw new Error(error);
  }
};
